/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createChatBlitzar = /* GraphQL */ `mutation CreateChatBlitzar($input: CreateChatBlitzarInput!
    $condition: ModelChatBlitzarConditionInput
  ) {
    createChatBlitzar(input: $input, condition: $condition) {
      id
      name
      message
      activity_id
      user_id
      event_id
      createdAt
    }
  }
`;
